import { createApi } from './api';
import { trim } from 'ramda';

export * from './api';

// Application Api
const api = createApi('app', {
    baseURL: `${trim(process.env.REACT_APP_API_URL || '')}${trim(
        process.env.REACT_APP_API_BASE_URL || '',
    )}`,
});

export default api;
